/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Input as ChakraInput,
  InputProps as ChakraInputProps,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Icon,
  InputGroup,
  InputLeftElement,
} from '@chakra-ui/react';
import { CreditCardIcon } from 'lucide-react';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import InputReactMask from 'react-input-mask';

interface IInputCardProps extends Omit<ChakraInputProps, 'size'> {
  name: string;
  label?: string;
  maskChar?: string;
}

//Tipagem com erro devido a versão do react-input-mask
const InputCardAny = InputReactMask as any;

export const InputCard: React.FC<IInputCardProps> = ({
  name,
  label,
  maskChar = null,
  ...rest
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <FormControl isInvalid={!!errors[name]}>
      {label && <FormLabel htmlFor={name}>{label}</FormLabel>}
      <InputGroup>
        <InputLeftElement>
          <Icon as={CreditCardIcon} />
        </InputLeftElement>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <InputCardAny
              mask="0000 0000 0000 0000"
              maskChar={maskChar}
              {...field}
            >
              {(inputProps: any) => (
                <ChakraInput id={name} {...inputProps} {...rest} bg="white" />
              )}
            </InputCardAny>
          )}
        />
      </InputGroup>
      <FormErrorMessage>
        {errors?.[name] && (errors[name]?.message as string)}
      </FormErrorMessage>
    </FormControl>
  );
};
